const productWrapper = document.querySelectorAll(".main-product__content")
const stickyAddtoCart = document.querySelector(".sticky-add-to-cart")
let qtyPlus = null
let qtyMinus = null
let qtyInput = null

productWrapper.forEach((product) => {
  qtyPlus = product.querySelector('button[name="plus"]')
  qtyMinus = product.querySelector('button[name="minus"]')
  qtyInput = product.querySelector('input[name="quantity"]')

  if (stickyAddtoCart) {
    qtyPlusSticky = stickyAddtoCart.querySelector('button[name="plus"]')
    qtyMinusSticky = stickyAddtoCart.querySelector('button[name="minus"]')
    qtyInputSticky = stickyAddtoCart.querySelector('input[name="quantity"]')
  }

  const qtyUpdates = (quantity) => {
    product.querySelector(".quantity input").value = quantity
    product.querySelector("#quantity").value = quantity

    if (stickyAddtoCart) {
      stickyAddtoCart.querySelector(".quantity input").value = quantity
      stickyAddtoCart.querySelector("#quantity").value = quantity
    }
  }

  if (product.querySelector(".quantity input")) {
    if (product.querySelector("#quantity")) {
      let quantity = parseInt(product.querySelector("#quantity").value)
      qtyPlus.addEventListener("click", function () {
        quantity = quantity + 1
        qtyUpdates(quantity)
      })

      qtyMinus.addEventListener("click", function () {
        if (quantity > 1) {
          quantity = quantity - 1
          qtyUpdates(quantity)
        }
      })

      qtyInput.addEventListener("change", function (e) {
        const inputQty = parseInt(e.target.value)
        if (inputQty > 0) {
          quantity = parseInt(e.target.value)
        }
        qtyUpdates(quantity)
      })

      qtyInput.addEventListener("keypress", function (e) {
        if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
          e.preventDefault()
        }
      })

      if (stickyAddtoCart && qtyPlusSticky && qtyMinusSticky && qtyInputSticky) {
        qtyPlusSticky.addEventListener("click", function () {
          quantity = quantity + 1
          qtyUpdates(quantity)
        })

        qtyMinusSticky.addEventListener("click", function () {
          if (quantity > 1) {
            quantity = quantity - 1
            qtyUpdates(quantity)
          }
        })

        qtyInputSticky.addEventListener("change", function (e) {
          const inputQty = parseInt(e.target.value)
          if (inputQty > 0) {
            quantity = parseInt(e.target.value)
          }
          qtyUpdates(quantity)
        })

        qtyInputSticky.addEventListener("keypress", function (e) {
          if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
            e.preventDefault()
          }
        })
      }
    }
  }
})
